import * as React from "react";
const SvgDel = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.601562 3.45703H13.173", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.0318 3.45703L11.549 11.6653C11.4992 12.511 10.7989 13.1713 9.95173 13.1713H3.82617C2.97901 13.1713 2.27868 12.511 2.22893 11.6653L1.74609 3.45703", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.45703 3.45871V2.60156C3.45703 1.49699 4.35246 0.601562 5.45703 0.601562H8.31418C9.41874 0.601562 10.3142 1.49699 10.3142 2.60156V3.45871", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.17188 6.31641V9.74498", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.60156 6.31641V9.74498", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDel;
